import { Component, ViewChild, TemplateRef, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'liberro-notification',
  standalone: false,
  templateUrl: './liberro-notification.component.html',
  styleUrl: './liberro-notification.component.less',
  encapsulation: ViewEncapsulation.None, // Global styles
})
export class LiberroNotificationComponent {
  @ViewChild('successTitleWithIcon', { static: true }) private successTitleWithIcon!: TemplateRef<void>;
  @ViewChild('errorTitleWithIcon', { static: true }) private errorTitleWithIcon!: TemplateRef<void>;
  @ViewChild('infoTitleWithIcon', { static: true }) private infoTitleWithIcon!: TemplateRef<void>;
  @ViewChild('warningTitleWithIcon', { static: true }) private warningTitleWithIcon!: TemplateRef<void>;

  @Input() public iconType: 'success' | 'error' | 'info' | 'warning' = 'success';
  @Input() public title = '';

  public get titleWithIconTemplate(): TemplateRef<void> {
    switch (this.iconType) {
      case 'success':
        return this.successTitleWithIcon;
      case 'error':
        return this.errorTitleWithIcon;
      case 'info':
        return this.infoTitleWithIcon;
      case 'warning':
        return this.warningTitleWithIcon;
      default:
        return this.successTitleWithIcon;
    }
  }
}
